import Vue from 'vue';
const plugins = {
	install(Vue) {
		const getScreenHeight = function() {
			return window.innerHeight;
		}
		Vue.prototype.$pageHeight = getScreenHeight;
	}
}
export default plugins;